shadow$provide[352] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Readback:{enumerable:true, get:function() {
  return Readback;
}}});
var UData = require("../../util/data.js");
var UGLSL = require("../../util/glsl.js");
var require$three = require("three");
var require$_DOT__SLASH_memo_DOT_js = require("./memo.js");
var require$_DOT__DOT__SLASH_meshes_SLASH_memoscreen_DOT_js = require("../meshes/memoscreen.js");
var require$_DOT__DOT__SLASH_renderable_DOT_js = require("../renderable.js");
class Readback extends require$_DOT__DOT__SLASH_renderable_DOT_js.Renderable {
  constructor(renderer, shaders, options) {
    super(renderer, shaders);
    if (this.items == null) {
      this.items = options.items || 1;
    }
    if (this.channels == null) {
      this.channels = options.channels || 4;
    }
    if (this.width == null) {
      this.width = options.width || 1;
    }
    if (this.height == null) {
      this.height = options.height || 1;
    }
    if (this.depth == null) {
      this.depth = options.depth || 1;
    }
    if (this.type == null) {
      this.type = options.type || require$three.FloatType;
    }
    if (this.stpq == null) {
      this.stpq = options.stpq || false;
    }
    this.isFloat = this.type === require$three.FloatType;
    this.active = this.sampled = this.rect = this.pad = null;
    this.build(options);
  }
  build(options) {
    let channels, encoder, stretch;
    const {map} = options;
    const {indexer} = options;
    const isIndexed = indexer != null && !indexer.empty();
    let {stpq} = this;
    const {items, width, height, depth} = this;
    let sampler = map;
    if (isIndexed) {
      this._adopt({indexModulus:{type:"v4", value:new require$three.Vector4(items, items * width, items * width * height, 1),},});
      sampler = this.shaders.shader();
      sampler.require(map);
      sampler.require(indexer);
      sampler.pipe("float.index.pack", this.uniforms);
    }
    if (this.isFloat && this.channels > 1) {
      this.floatMemo = new require$_DOT__SLASH_memo_DOT_js.Memo(this.renderer, this.shaders, {items, channels:4, width, height, depth, history:0, type:require$three.FloatType,});
      this.floatCompose = new require$_DOT__DOT__SLASH_meshes_SLASH_memoscreen_DOT_js.MemoScreen(this.renderer, this.shaders, {map:sampler, items, width, height, depth, stpq,});
      this.floatMemo.adopt(this.floatCompose);
      stpq = false;
      sampler = this.shaders.shader();
      this.floatMemo.shaderAbsolute(sampler);
    }
    if (this.isFloat) {
      stretch = this.channels;
      channels = 4;
    } else {
      stretch = 1;
      channels = this.channels;
    }
    if (stretch > 1) {
      encoder = this.shaders.shader();
      encoder.pipe(UGLSL.mapByte2FloatOffset(stretch));
      encoder.require(sampler);
      encoder.pipe("float.stretch");
      encoder.pipe("float.encode");
      sampler = encoder;
    } else if (this.isFloat) {
      encoder = this.shaders.shader();
      encoder.pipe(sampler);
      encoder.pipe(UGLSL.truncateVec(4, 1));
      encoder.pipe("float.encode");
      sampler = encoder;
    }
    this.byteMemo = new require$_DOT__SLASH_memo_DOT_js.Memo(this.renderer, this.shaders, {items:items * stretch, channels:channels, width, height, depth, history:0, type:require$three.UnsignedByteType,});
    this.byteCompose = new require$_DOT__DOT__SLASH_meshes_SLASH_memoscreen_DOT_js.MemoScreen(this.renderer, this.shaders, {map:sampler, items:items * stretch, width, height, depth, stpq,});
    this.byteMemo.adopt(this.byteCompose);
    const w = items * width * stretch;
    const h = height * depth;
    this.samples = this.width * this.height * this.depth;
    this.bytes = new Uint8Array(w * h * 4);
    if (this.isFloat) {
      this.floats = new Float32Array(this.bytes.buffer);
    }
    this.data = this.isFloat ? this.floats : this.bytes;
    this.streamer = this.generate(this.data);
    this.active = {items:0, width:0, height:0, depth:0};
    this.sampled = {items:0, width:0, height:0, depth:0};
    this.rect = {w:0, h:0};
    this.pad = {x:0, y:0, z:0, w:0};
    this.stretch = stretch;
    this.isIndexed = isIndexed;
    return this.setActive(items, width, height, depth);
  }
  generate(data) {
    return UData.getStreamer(data, this.samples, 4, this.items);
  }
  setActive(items, width, height, depth) {
    let ref;
    if (items === this.active.items && width === this.active.width && height === this.active.height && depth === this.active.depth) {
      return;
    }
    [this.active.items, this.active.width, this.active.height, this.active.depth] = Array.from([items, width, height, depth]);
    if (this.floatCompose != null) {
      this.floatCompose.cover(width, height, depth);
    }
    if (this.byteCompose != null) {
      this.byteCompose.cover(width * this.stretch, height, depth);
    }
    ({items} = this);
    ({width} = this.active);
    height = this.depth === 1 ? this.active.height : this.height;
    ({depth} = this.active);
    const w = items * width * this.stretch;
    const h = height * depth;
    [this.sampled.items, this.sampled.width, this.sampled.height, this.sampled.depth] = Array.from([items, width, height, depth]);
    [this.rect.w, this.rect.h] = Array.from([w, h]);
    return [this.pad.x, this.pad.y, this.pad.z, this.pad.w] = Array.from(ref = [this.sampled.width - this.active.width, this.sampled.height - this.active.height, this.sampled.depth - this.active.depth, this.sampled.items - this.active.items,]), ref;
  }
  update(camera) {
    if (this.floatMemo != null) {
      this.floatMemo.render(camera);
    }
    return this.byteMemo != null ? this.byteMemo.render(camera) : undefined;
  }
  post() {
    const currentTarget = this.renderer.getRenderTarget();
    this.renderer.setRenderTarget(this.byteMemo.target.targets[0]);
    this.gl.readPixels(0, 0, this.rect.w, this.rect.h, this.gl.RGBA, this.gl.UNSIGNED_BYTE, this.bytes);
    this.renderer.setRenderTarget(currentTarget);
  }
  readFloat(n) {
    return this.floatMemo != null ? this.floatMemo.read(n) : undefined;
  }
  readByte(n) {
    return this.byteMemo != null ? this.byteMemo.read(n) : undefined;
  }
  setCallback(callback) {
    this.emitter = this.callback(callback);
  }
  callback(callback) {
    if (!this.isIndexed) {
      return callback;
    }
    const n = this.width;
    const m = this.height;
    const p = this.items;
    const f = function(x, y, z, w) {
      let idx = w;
      const ll = idx % p;
      idx = (idx - ll) / p;
      const ii = idx % n;
      idx = (idx - ii) / n;
      const jj = idx % m;
      idx = (idx - jj) / m;
      const kk = idx;
      return callback(x, y, z, w, ii, jj, kk, ll);
    };
    f.reset = () => typeof callback.reset === "function" ? callback.reset() : undefined;
    return f;
  }
  iterate() {
    let j, k, l;
    let emit = this.emitter;
    if (typeof emit.reset === "function") {
      emit.reset();
    }
    const {consume, skip, count, done, reset} = this.streamer;
    reset();
    const n = this.sampled.width | 0;
    let m = this.sampled.height | 0;
    const o = this.sampled.depth | 0;
    const p = this.sampled.items | 0;
    const padX = this.pad.x | 0;
    const padY = this.pad.y | 0;
    const padZ = this.pad.z | 0;
    const padW = this.pad.w | 0;
    const limit = n * m * p * (o - padZ);
    if (!this.isIndexed) {
      const callback = emit;
      emit = (x, y, z, w) => callback(x, y, z, w, i, j, k, l);
    }
    let i = j = k = l = m = 0;
    while (!done() && m < limit) {
      m++;
      const repeat = consume(emit);
      if (++l === p - padW) {
        skip(padX);
        l = 0;
        if (++i === n - padX) {
          skip(p * padX);
          i = 0;
          if (++j === m - padY) {
            skip(p * n * padY);
            j = 0;
            k++;
          }
        }
      }
      if (repeat === false) {
        break;
      }
    }
    return Math.floor(count() / p);
  }
  dispose() {
    if (this.floatMemo != null) {
      this.floatMemo.unadopt(this.floatCompose);
    }
    if (this.floatMemo != null) {
      this.floatMemo.dispose();
    }
    if (this.floatCompose != null) {
      this.floatCompose.dispose();
    }
    if (this.byteMemo != null) {
      this.byteMemo.unadopt(this.byteCompose);
    }
    if (this.byteMemo != null) {
      this.byteMemo.dispose();
    }
    if (this.byteCompose != null) {
      this.byteCompose.dispose();
    }
    return this.floatMemo = this.byteMemo = this.floatCompose = this.byteCompose = null;
  }
}

};